import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideZoneChangeDetection } from '@angular/core';
import { AppComponent } from './app/app.component';
import { GameService } from './app/services/game.service';
import { CommentService } from './app/services/comment.service';
import { ContentService } from './app/services/content.service';
import { AccountService } from './app/services/account.service';
import { IconsService } from './app/services/icons.service';
import { FilesService } from './app/services/files.service';
import { OpenAiService } from './app/services/open-ai.service';
import { VocabularyService } from './app/services/vocabulary.service';
import { ScreenOptionsService } from './app/services/screen-options.service';
import { FrameAuthService } from './app/services/frame-auth.service';
import { authInterceptor } from './app/services/auth.interceptor';
import { routes } from './app/app-routes';
import { provideCustomLocale } from '@onclass/oc-custom-locale';
import { get_lang, LANG_MAP, LANGS } from './app/services/i18n';

// Загружаем переводы синхронно перед bootstrap
(async () => {
  const lang = get_lang();
  let translations: Record<string, string> = {};

  if (lang && LANGS.includes(lang)) {
    const module = await (LANG_MAP as Record<string, () => Promise<any>>)[
      lang
    ]();
    translations = module.default || module;
    // Устанавливаем в оба ключа для совместимости
    (window as any)['__custom__locale__translations__'] = translations;
    (window as any)['__custom__locale__translations'] = translations;
  }

  bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection(),
      provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
      provideAnimations(),
      provideRouter(routes),
      provideCustomLocale(translations),
      GameService,
      CommentService,
      ContentService,
      AccountService,
      IconsService,
      FilesService,
      OpenAiService,
      VocabularyService,
      ScreenOptionsService,
      FrameAuthService,
    ],
  }).catch((err) => {});
})();
